import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

// This hook is used to get the assignmentId from the URL and store it in sessionStorage
// It is used for creating a session with a specific assignmentId
export const useSessionStorageAssignmentId = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const assignmentId = searchParams.get("assignmentId") ?? undefined;

    if (assignmentId) {
      sessionStorage.setItem("assignmentId", assignmentId);
    }
  }, [searchParams]);

  return sessionStorage.getItem("assignmentId");
};
